
import Vue from "vue";
import { INode } from "@/shared/models/node.model";

export default Vue.extend({
    name: "ChapterItem",
    props: {
        item: Object as () => INode,
        activeNodeId: Number
    },
    data() {
        return {
            isLongName: false as boolean,
        };
    },

    mounted() {
        if (this.item.Name.length > 35) {
            this.isLongName = true;
        }
    },
    methods: {
        showTree(selectedChapter: INode) {
            this.$emit("show-tree", selectedChapter);
        },
    }
});
